import axios from "axios";
import { getToken } from "../../auth/authService";

const BASE = process.env.REACT_APP_BASE_URL;

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const fetchAllWebImages = async () => {
  try {
    const res = await axios.get(`${BASE}/admin/web-images`, { headers: authHeaders() });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: [], message: err.response?.data?.message || "Failed to fetch images" };
  }
};

export const uploadWebImage = async (file, name, category) => {
  try {
    const form = new FormData();
    form.append("file", file);
    form.append("name", name);
    form.append("category", category);

    const res = await axios.post(`${BASE}/admin/web-images/upload`, form, {
      headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
    });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Upload failed" };
  }
};

export const replaceWebImage = async (id, file) => {
  try {
    const form = new FormData();
    form.append("file", file);

    const res = await axios.put(`${BASE}/admin/web-images/${id}/replace`, form, {
      headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
    });
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Replace failed" };
  }
};

export const deleteWebImage = async (id) => {
  try {
    const res = await axios.delete(`${BASE}/admin/web-images/${id}`, { headers: authHeaders() });
    return { status: res.status };
  } catch (err) {
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" };
  }
};
